import * as angular from 'angular';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OrganizationHelpers, OrganizationResource } from '@mode/legacy/data-access-model-js';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OrganizationFeatureResource, OrganizationFeatures } from '@mode/legacy/data-access-model-js';
import { AccountFacade } from '@mode/accounts/contract';
import { Observable } from 'rxjs';

/**
 * @todo (Franklin) 03/16/2020: Merge with {@link MembersPanelComponent} https://github.com/mode/issues/issues/2931
 */
class MembersController {
  static $inject = ['AccountFacade'];

  private $resolve: any;
  private organization!: OrganizationResource;
  private orgFeatures!: OrganizationFeatureResource;
  private orgIsManagedByScim!: boolean;
  private orgSeatLimitReached!: boolean;
  private thoughtspotIntegrated = false;

  constructor(private _accountFacade: AccountFacade) {}

  $onInit() {
    this.organization = this.$resolve.organization;
    this.orgFeatures = this.$resolve.orgFeatures;
    this.orgIsManagedByScim = this.$resolve.orgIsManagedByScim;
    this._accountFacade.hasOrgSeatLimitReached$.subscribe((value) => (this.orgSeatLimitReached = value));
    this.thoughtspotIntegrated = this.orgIsThoughtspotIntegrated();
  }

  orgName() {
    return this.organization.name;
  }

  orgUsername() {
    return this.organization.username;
  }

  orgNewInviteLink() {
    return OrganizationHelpers.getNewInviteLink(this.organization);
  }

  orgHistoryLink() {
    return OrganizationHelpers.getMembershipEventsLink(this.organization);
  }

  orgMemberSessionsLink() {
    return OrganizationHelpers.getMemberSessionsLink(this.organization);
  }

  orgScimEnabled() {
    return OrganizationHelpers.IsScimEnabled(this.organization);
  }

  orgIsThoughtspotIntegrated() {
    return OrganizationHelpers.IsThoughtspotIntegrated(this.organization);
  }

  orgLimitedMembershipsEnabled() {
    return this.orgFeatures[OrganizationFeatures.Type.LimitedMemberships];
  }

  readerIsOrgAdmin() {
    return OrganizationHelpers.isOrgAdmin(this.organization);
  }
}

export const MembersComponent: angular.IComponentOptions = {
  controller: MembersController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <mode-studio-seat-limit-banner ng-if="ctrl.orgSeatLimitReached"
      class="members-panel-studio-seat-limit-banner"
      [paid-plan]="ctrl.organization.plan_code==='plus'"
      ></mode-studio-seat-limit-banner>

    <members-panel
      admin-enabled="ctrl.readerIsOrgAdmin()"
      org-name="ctrl.orgName()"
      org-username="ctrl.orgUsername()"
      org-is-managed-by-scim="ctrl.orgIsManagedByScim"
      new-invite-link="ctrl.orgNewInviteLink()"
      history-link="ctrl.orgHistoryLink()"
      member-sessions-link="ctrl.orgMemberSessionsLink()"
      limited-memberships-enabled="ctrl.orgLimitedMembershipsEnabled()"
      member-filter="ctrl.$resolve.memberFilter"
      scim-enabled="ctrl.orgScimEnabled()"
      thoughtspot-integrated="ctrl.thoughtspotIntegrated"
    />
  `,
};
